export const SCROLLBAR_HARMONISATION_ATTRIBUTE = 'data-scrollbar-harmonisation';
